import { Logo } from '@waago/ui'

/**
 * AC-001 splash — Figma frame `2389:3178`.
 *
 * Three stacked cards on a navy page, each with a 24px bottom radius, so the
 * brand panel appears to sit on a small deck. Sizes are the frame's own
 * (641/688/728 of 799), expressed as percentages so the effect survives a
 * taller viewport.
 *
 * Rendered by `RequireAuth` while the refresh cookie is being exchanged: the
 * splash is the session restore, not a timed delay in front of it.
 */
export default function SplashPage() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-[420px] flex-col bg-[#132958]">
      <div className="relative flex-1">
        <div className="absolute inset-x-0 top-0 h-[91.1%] rounded-b-2xl bg-[#174291]" />
        <div className="absolute inset-x-0 top-0 h-[86.1%] rounded-b-2xl bg-[#154ab8]" />
        <div
          className="absolute inset-x-0 top-0 flex h-[80.2%] items-center justify-center rounded-b-2xl"
          style={{ backgroundImage: 'var(--gradient-splash)' }}
        >
          {/* 246x81 in the frame — larger than the wordmark used elsewhere. */}
          <Logo tone="white" className="h-[81px] w-[246px]" />
        </div>
      </div>
      <p className="animate-slide-up sr-only" role="status">
        Chargement de WaaGo
      </p>
    </div>
  )
}
